import React, { Component } from 'react';
import {
  createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import { Provider } from 'react-redux';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';

/* eslint import/no-extraneous-dependencies: 0 */
import { createDevTools } from 'redux-devtools';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import App from './containers/App';
import cable from './cable';
import * as allReducers from './reducers';
import tutorialOutcomeMiddleware from './components/tutorial/tutorialOutcomeMiddleware';
import { samePageLocationMiddleware } from './util/samePageLocationChange';
import { dropOnAppSignInPages, startThirdPartyServices } from './util/thirdPartyServices';

const reducers = combineReducers({
  ...allReducers,
  router: routerReducer,
});

const history = createBrowserHistory();
const middleware = routerMiddleware(history);

// PostHog (off in development) and the page scripts the server holds back on an iOS app sign-in
// page start on the first ordinary page of this load (util/thirdPartyServices.js).
startThirdPartyServices({
  history,
  startAnalytics: process.env.NODE_ENV === 'development' ? undefined : () => posthog.init(
    process.env.PUBLIC_POSTHOG_KEY,
    {
      api_host: process.env.PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      before_send: dropOnAppSignInPages,
    },
  ),
});

export const CableApp = { cable };

const DevTools = createDevTools(
  <DockMonitor
    toggleVisibilityKey="ctrl-h"
    changePositionKey="ctrl-q"
    defaultIsVisible={false}
  >
    <LogMonitor theme="tomorrow" />
  </DockMonitor>,
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
if (process.env.NODE_ENV === 'development') {
  console.log('Running in development!');
}
const enhancer = composeEnhancers(
  applyMiddleware(samePageLocationMiddleware, middleware, thunkMiddleware, tutorialOutcomeMiddleware),
);

export const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  enhancer,
);

export default class Medsender extends Component {
  render() {
    if (process.env.NODE_ENV === 'development') {
      return (
        <Provider store={store}>
          <>
            <App history={history} cable={CableApp.cable} />
            <DevTools />
          </>
        </Provider>
      );
    }

    return (
      <Provider store={store}>
        <>
          <PostHogProvider client={posthog}>
            <App history={history} cable={CableApp.cable} />
          </PostHogProvider>
        </>
      </Provider>
    );
  }
}
